import RecaptchaCore from './RecaptchaCore';
import withBootstrapSitekey from './withBootstrapSitekey';
import withAutoLoad from './withAutoLoad';

export default withAutoLoad(withBootstrapSitekey(RecaptchaCore));
